import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService
    ) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        let path: string[] = [];
        let iterations = 10;
        do {
            if (next.url) {
                let tmp: string[] = [];
                for (let segment of next.url)
                    tmp.push(segment.path);
                tmp.reverse();
                path.push(...tmp);
            }
            next = next.parent;
            iterations--;
        } while (next.url && next.url.length > 0 && !next.url.map(u => u.path).some(v => v.toLowerCase() === 'app')
        && path.length < 10 && iterations > 0);
        path.push('app');
        path.reverse();
        return this.authService.isAuthenticated$
            .do(isLogged => !isLogged && this.router.navigate(['/welcome', { returnTo: path }]));
    }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/auth.guard.ts